import {Box} from '@mui/material';
import {useMemo, useState, memo} from 'react';

import {dayArray, formatedString, monthsArray, yearsArray} from '../items';
import 'react-spring-bottom-sheet/dist/style.css';
import 'assets/css/wheelpicker.css';
import Wheel from './Wheel';
import ButtonContainer from './ButtonContainer';

const Birthdate = memo(({changeHandler, closeToastHandler, value}) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedDay, setSelecteDay] = useState(null);

  const monthIndex = selectedMonth?.rel + 1;

  const monthWith29Days = monthIndex === 12;
  const monthWith30days = monthIndex > 6 && monthIndex !== 12;

  const daysLength = monthWith30days ? 30 : monthWith29Days ? 29 : 31;

  const years = useMemo(() => yearsArray(), []);
  const months = useMemo(() => monthsArray, []);
  const days = useMemo(() => dayArray(daysLength), [selectedMonth?.rel]);

  const userBirthdate = value?.split('/') || '';
  const [year, month, day] = userBirthdate;

  const initialDayIndex = +day ? +day - 1 : 0;
  const initailYearIndex = year
    ? years?.findIndex((item) => item === +year)
    : 50;

  const birtdateString = `${years?.[selectedYear?.rel]}/${formatedString(
    monthIndex
  )}/${formatedString(days?.[selectedDay?.rel])}`;

  return (
    <>
      <Box className={'headerContainer'}>
        <div className='wheel__label' style={{width: '25%'}}>
          سال
        </div>
        <div className='wheel__label' style={{width: '50%'}}>
          ماه
        </div>
        <div className='wheel__label' style={{width: '23%'}}>
          روز
        </div>
      </Box>
      <div onChange={(e) => e.stopPropagation()} className='timepickerWrapper'>
        <div
          className={'columnStyle_Year'}
          style={{borderRight: '1px solid #d8d8d8'}}>
          <Wheel
            loop
            width={110}
            setSelected={setSelectedYear}
            length={years.length}
            perspective='center'
            items={years}
            addletterSpacing
            initIdx={initailYearIndex}
          />
        </div>
        <div
          className={'columnStyle_Month'}
          style={{borderRight: '1px solid #d8d8d8'}}>
          <Wheel
            loop
            year={true}
            width={110}
            items={months}
            length={months.length}
            perspective='center'
            setSelected={setSelectedMonth}
            initIdx={month ? +month - 1 : 0}
          />
        </div>
        <div className={'columnStyle_day '}>
          <Wheel
            loop
            width={110}
            items={days}
            length={daysLength}
            setSelected={setSelecteDay}
            perspective='center'
            addletterSpacing
            initIdx={initialDayIndex}
          />
        </div>
      </div>
      <ButtonContainer
        closeToastHandler={closeToastHandler}
        changeHandler={changeHandler}
        value={birtdateString}
      />
    </>
  );
});

export default Birthdate;
